import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { editSector, getSector } from '../../../../actions/ticketing/sectorsActions'
import SectorForm from '../../../../components/forms/sectors/SectorForm'

export default function EditSector({usertype, selectedSector}) {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
    const navigate = useNavigate()

	const {result, loading, sector} = useSelector(state=>state.sectors)

    const [sectorForm, setSectorForm] = useState({
        name: null,
        maxCapacity: '0',
        numerated: false,
        active: true,
        distribution: {
            rows: '0',
            columns: '0',
            numeration: '0',
            deleted: []
        },
        schedule: {
            openTime: "00:00",
            closeTime: "23:59",
            dailySchedule: [],
            useDailySchedule: true
        },
        club: null
    })

    const handleEdit = async(e) => {
        e.preventDefault()

        if(sectorForm.name !== ''){
            // Agregar useDailySchedule: true al schedule
            const sectorData = {
                ...sectorForm,
                schedule: {
                    ...sectorForm.schedule,
                    useDailySchedule: true
                }
            }
            dispatch(editSector(sector?._id, sectorData))
        }else{
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: false,
                confirmButtonText: t('global.ok'),
                icon: 'warning',
                text: t('sectors.noName')
            })
        }
    }

    useEffect(() => {
        if(result){
            let newresult = result.message
            dispatch({
                type: 'SECTOR_RESET_RESULT'
            })
            switch (newresult) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('sectors.editSuccess')
                    }).then(() => {
                        if(usertype === 'superadmin'){
                            navigate(`/${t("url.admin.admin")}/${t("url.admin.club")}/${t("url.admin.sectors")}`)
                        }else{
                            navigate(`/${t("url.club.club")}/${t("url.club.sectors")}`)
                        }
                    })
                    break;
                case 'duplicateName':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('sectors.duplicateName')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [result])

    useEffect(() => {
        if (selectedSector) {
            dispatch(getSector(selectedSector))
        }
    }, [selectedSector, dispatch])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (sector) {
            console.log("Sector data:", sector)
            
            // Convertir estructura del backend a la estructura del frontend
            let newSchedule = {
                openTime: "00:00",
                closeTime: "23:59",
                dailySchedule: [],
                useDailySchedule: true
            }

            // Si el sector tiene datos de horario
            if (sector?.schedule) {
                if (sector.schedule.dailySchedule) {
                    // Ya tiene la estructura del backend
                    newSchedule = {
                        openTime: sector.schedule.openTime || "00:00",
                        closeTime: sector.schedule.closeTime || "23:59",
                        dailySchedule: sector.schedule.dailySchedule || [],
                        useDailySchedule: sector.schedule.useDailySchedule || true
                    }
                } else if (sector.schedule.days && sector.schedule.openTime && sector.schedule.closeTime) {
                    // Estructura antigua - convertir a dailySchedule
                    newSchedule.dailySchedule = sector.schedule.days.map(day => ({
                        day: day,
                        openTime: sector.schedule.openTime,
                        closeTime: sector.schedule.closeTime,
                        active: true
                    }))
                }
            }

            setSectorForm({
                name: sector?.name,
                maxCapacity: sector?.maxCapacity,
                numerated: sector?.numerated || false,
                active: sector?.active || false,
                distribution: sector?.distribution || {
                    rows: '0',
                    columns: '0',
                    numeration: '0',
                    deleted: []
                },
                schedule: newSchedule,
                club: sector?.club
            })
        }
    }, [sector])

	return (
        <Container className='cuerpo'>
            <Row className="my-3">
                <Col>
                    <h1 className='ms-2 my-0'>{t('sectors.editSectorForm')}</h1>
                </Col>
            </Row>
            <Row className="my-3">
                <Col>
                    <Card>
                        <Card.Body>
                            <SectorForm state={sectorForm} statetype={'edit'} usertype={usertype} isAdding={loading} submit={handleEdit} setState={setSectorForm}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
	)
}